import Vue from 'vue'
import router from '../../router/';
import {
  AUTH_LOGIN,
  AUTH_LOGOUT, CHANGE_SESSION, CHANGE_USER_WORK_STATUS,
  CREATE_USER, DELETE_SESSION, DISABLE_2FA,
  EDIT_BALANCE, EDIT_SUPPORT_LIMIT,
  EDIT_USER, ENABLE_2FA, GET_2FA_DATA, LOAD_BALANCE, LOAD_USERS_PROJECTS,
  LOAD_USERS_LIST, RESET_SUPPORT_LIMIT, LOAD_PROJECTS
} from '../const/user';
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import { RESET_ORDERS } from "@/store/const/orders";

export default {
  namespaced: true,
  state: {
    id: localStorage.getItem('id') || '',
    token: localStorage.getItem('token') || '',
    username: localStorage.getItem('username') || '',
    role: localStorage.getItem('role') || '',
    sessions: localStorage.getItem('sessions') ? JSON.parse(localStorage.getItem('sessions')) : [],
    projects: [],
    balance: 0,
    balanceDep: 0,
    balanceCredit: 0,
    balanceUsdt: 0,
    balanceDepUsdt: 0,
    balanceCreditUsdt: 0,
    fee: 0,
    feeClean: 0,
    feeUsdt: 0,
    feeCleanUsdt: 0,
    users: [],
    usersProjects: [],
  },
  getters: {
    sessions: state => state.sessions,
    getRole: state => state.role,
    getToken: state => state.token,
    isAdmin: state => state.role === 'admin' || state.role === 'superadmin',
    isSuperadmin: state => state.role === 'superadmin',
    isSupport: state => state.role === 'support',
    isClient: state => state.role === 'client',
    users: state => state.users,
    usersProjects: state => state.usersProjects,
    username: state => state.username,
    balance: state => state.balance,
    balanceDep: state => state.balanceDep,
    balanceCredit: state => state.balanceCredit,
    balanceAvailable: state => parseFloat((state.balanceCredit + state.balance).toFixed(8)),
    balanceUsdt: state => state.balanceUsdt,
    balanceDepUsdt: state => state.balanceDepUsdt,
    balanceCreditUsdt: state => state.balanceCreditUsdt,
    balanceAvailableUsdt: state => parseFloat((state.balanceCreditUsdt + state.balanceUsdt).toFixed(2)),
    projects: state => state.projects,
    availableProjects: (state, getters) => getters.isAdmin ? getters.usersProjects : getters.projects,
    fee: state => state.fee,
    feeClean: state => state.feeClean,
    feeUsdt: state => state.feeUsdt,
    feeCleanUsdt: state => state.feeCleanUsdt,
  },
  actions: {
    [AUTH_LOGIN]: async ({ dispatch, commit }, { name, password, data }) => {
      const request = await dispatch(HTTP_POST, {
        method: AUTH_LOGIN,
        body: { name, password, data },
        with_token: false,
        no_commit: true,
        namespace: 'user',
      }, { root: true });

      if (request && request.data) {
        const data = request.data;
        const token = data.token;
        const user = data.user;

        commit(AUTH_LOGIN, {
          token,
          username: user.name,
          role: user.role,
          isNewSession: true,
        });
        await router.push({ name: 'Orders' });
      }
      return request;
    },
    [AUTH_LOGOUT]: async ({ commit }) => {
      commit(`orders/${RESET_ORDERS}`, null, { root: true });
      commit(AUTH_LOGOUT);
      await router.push({ name: 'Login' });
    },
    [CHANGE_SESSION]: async ({ commit }, session) => {
      commit(`orders/${RESET_ORDERS}`, null, { root: true });
      commit(AUTH_LOGIN, { ...session, isNewSession: false });
      await router.push({ name: 'Orders' });
    },
    [DELETE_SESSION]: async ({ commit }, session) => {
      commit(`orders/${RESET_ORDERS}`, null, { root: true });
      commit(DELETE_SESSION, session.username);
    },
    [LOAD_USERS_LIST]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_USERS_LIST,
        namespace: 'user',
      }, { root: true });
    },
    [CREATE_USER]: async ({ dispatch }, user) => {
      return await dispatch(HTTP_POST, {
        method: CREATE_USER,
        namespace: 'user',
        body: user,
        no_commit: true,
      }, { root: true });
    },
    [EDIT_USER]: async ({ dispatch }, { name, data }) => {
      return await dispatch(HTTP_PUT, {
        method: EDIT_USER,
        namespace: 'user',
        body: data,
        replace: { name },
        no_commit: true,
      }, { root: true });
    },
    [EDIT_BALANCE]: async ({ dispatch }, { name, data }) => {
      return await dispatch(HTTP_PUT, {
        method: EDIT_BALANCE,
        namespace: 'user',
        body: data,
        replace: { name },
        no_commit: true,
      }, { root: true });
    },
    [CHANGE_USER_WORK_STATUS]: async ({ dispatch }, { data, status }) => {
      return await dispatch(HTTP_PUT, {
        method: CHANGE_USER_WORK_STATUS,
        namespace: 'user',
        replace: { status },
        body: data,
        no_commit: true,
      }, { root: true });
    },
    [EDIT_SUPPORT_LIMIT]: async ({ dispatch }, { id, data }) => {
      return await dispatch(HTTP_PUT, {
        method: EDIT_SUPPORT_LIMIT,
        namespace: 'user',
        body: data,
        replace: { id },
        no_commit: true,
      }, { root: true });
    },
    [RESET_SUPPORT_LIMIT]: async ({ dispatch }, { id }) => {
      return await dispatch(HTTP_PUT, {
        method: RESET_SUPPORT_LIMIT,
        namespace: 'user',
        replace: { id },
        no_commit: true,
      }, { root: true });
    },
    [GET_2FA_DATA]: async ({ dispatch }) => {
      return await dispatch(HTTP_GET, {
        method: GET_2FA_DATA,
        namespace: 'user',
        no_commit: true,
      }, { root: true });
    },
    [ENABLE_2FA]: async ({ dispatch }, { token, secret }) => {
      return await dispatch(HTTP_POST, {
        method: ENABLE_2FA,
        namespace: 'user',
        body: { token, secret },
        no_commit: true,
      }, { root: true });
    },
    [DISABLE_2FA]: async ({ dispatch }, { token }) => {
      return await dispatch(HTTP_DELETE, {
        method: DISABLE_2FA,
        namespace: 'user',
        body: { token },
        no_commit: true,
      }, { root: true });
    },
    [LOAD_BALANCE]: async ({ dispatch }) => {
      return await dispatch(HTTP_GET, {
        method: LOAD_BALANCE,
        namespace: 'user',
      }, { root: true });
    },
    [LOAD_PROJECTS]: async ({ dispatch }) => {
      return await dispatch(HTTP_GET, {
        method: LOAD_PROJECTS,
        namespace: 'user',
      }, { root: true });
    },
    [LOAD_USERS_PROJECTS]: async ({ dispatch }) => {
      return await dispatch(HTTP_GET, {
        method: LOAD_USERS_PROJECTS,
        namespace: 'user',
      }, { root: true });
    },
  },
  mutations: {
    [AUTH_LOGIN]: (state, { token, username, role, isNewSession }) => {
      localStorage.setItem('token', token);
      localStorage.setItem('username', username);
      localStorage.setItem('role', role);
      if (isNewSession) {
        const sessions = [...state.sessions, { token, username, role }];
        localStorage.setItem('sessions', JSON.stringify(sessions));
        Vue.set(state, 'sessions', sessions);
      }
      Vue.set(state, 'token', token);
      Vue.set(state, 'username', username);
      Vue.set(state, 'role', role);
    },
    [AUTH_LOGOUT]: (state) => {
      localStorage.removeItem('username');
      localStorage.removeItem('role');
      localStorage.removeItem('users');
      localStorage.removeItem('token');
      const sessions = state.sessions.filter((session) => session.username !== state.username);
      localStorage.setItem('sessions', JSON.stringify(sessions));
      Vue.set(state, 'token', '');
      Vue.set(state, 'username', '');
      Vue.set(state, 'role', '');
      Vue.set(state, 'users', []);
      Vue.set(state, 'sessions', sessions);
    },
    [DELETE_SESSION]: (state, username) => {
      const sessions = state.sessions.filter((session) => session.username !== username);
      localStorage.setItem('sessions', JSON.stringify(sessions));
      Vue.set(state, 'sessions', sessions);
    },
    [LOAD_USERS_LIST]: (state, { data }) => {
      if (data) {
        Vue.set(state, 'users', data);
      }
    },
    [LOAD_BALANCE]: (state, { data }) => {
      if (data) {
        Vue.set(state, 'balance', data.balance);
        Vue.set(state, 'balanceDep', data.balanceDep);
        Vue.set(state, 'balanceCredit', data.balanceCredit);
        Vue.set(state, 'balanceUsdt', data.balanceUsdt);
        Vue.set(state, 'balanceDepUsdt', data.balanceDepUsdt);
        Vue.set(state, 'balanceCreditUsdt', data.balanceCreditUsdt);
        Vue.set(state, 'fee', data.fee);
        Vue.set(state, 'feeClean', data.feeClean);
        Vue.set(state, 'feeUsdt', data.feeUsdt);
        Vue.set(state, 'feeCleanUsdt', data.feeCleanUsdt);
      }
    },
    [LOAD_PROJECTS]: (state, { data }) => {
      if (data) {
        Vue.set(state, 'projects', data);
      }
    },
    [LOAD_USERS_PROJECTS]: (state, { data }) => {
      if (data) {
        Vue.set(state, 'usersProjects', data);
      }
    },
  },
};
